import React from 'react';
import IndustryPageTemplate from '@/components/IndustryPageTemplate';
import { industryAds } from '@/config/ads';

const EntertainmentAndMedia: React.FC = () => {
  return (
    <IndustryPageTemplate
      slug="entertainment-and-media"
      industry="Entertainment & Media"
      heroHeadline="Turn static promotions into immersive previews that drive real excitement."
      heroSubheadline="Create interactive trailers, multi-frame storytelling, and engaging experiences that build anticipation."
      section2Title="Interactive trailers and multi-frame storytelling perform better."
      section2Content="Entertainment marketing is about building excitement. Interactive ads let audiences explore trailers, browse cast and characters, and engage with content in ways that static banners simply can't match."
      section3Title="Higher engagement improves awareness and subscriber acquisition."
      section3Content="When audiences can interact with your content—watching clips, exploring storylines, and engaging with characters—they develop stronger connections that translate to viewership and subscriptions."
      section4Title="Ideal for streaming services, film studios, and gaming."
      section4Content="Whether you're launching a blockbuster, promoting a new series, or driving game downloads, Adventive helps you create the immersive promotional experiences that cut through the noise."
      heroImage="https://d64gsuwffb70l.cloudfront.net/69408eb499b5789ef7367cf9_1765838709366_36c6b285.jpg"
      heroAd={industryAds.entertainmentAndMedia1}
      section2Ad={industryAds.entertainmentAndMedia2}
      section3Ad={industryAds.entertainmentAndMedia3}
      accentColor="bg-red-100 text-red-700"
      stats={[
        { value: '5x', label: 'Engagement rate' },
        { value: '+120%', label: 'Video completion' },
        { value: '3.2x', label: 'Intent to watch' },
        { value: '40%', label: 'Lower CPA' },
      ]}
      benefits={[
        'Streaming services and platforms',
        'Film and TV studios',
        'Gaming publishers',
        'Music labels and live events',
      ]}
    />
  );
};

export default EntertainmentAndMedia;
